export const getEntryOriginLabel = (value) =>
  typeof value === "string" && value.trim() === "Ex-Procore"
    ? "Deleted - Procore"
    : value;
